/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'REFERENCE_TO_NATIONAL_LAW',
              'REFERENCE_TO_INTERNATIONAL_LAW_ILO_CONVENTIONS',
              'REFERENCE_TO_OTHER_NATIONAL_OR_INTERNATIONAL_REQUIREMENTS_DECLA',
              'NO_REFERENCES_TO_ANY_OF_THE_ABOVE',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    do_these_policies_andor_procedures_have_a_reference_to_national: valueSchema,
  },
}
